import * as React from 'react';
const Wifi = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-wifi", ...props },
    React.createElement("path", { d: "M5 12.55a11 11 0 0 1 14.08 0" }),
    React.createElement("path", { d: "M1.42 9a16 16 0 0 1 21.16 0" }),
    React.createElement("path", { d: "M8.53 16.11a6 6 0 0 1 6.95 0" }),
    React.createElement("line", { x1: "12", y1: "20", x2: "12", y2: "20" })));
export default Wifi;
//# sourceMappingURL=Wifi.js.map